<template>
  <a-modal
    width="1000px"
    :title="modalTitel"
    :visible="visible"
    v-if="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-form-item
        label="预约老师"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'tname',
            {
              initialValue: planDetail.english_name
            }
          ]"
          disabled/>
      </a-form-item>
      <a-form-item
        label="预约日期"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'days',
            {
              initialValue: planDetail.days
            }
          ]"
          disabled/>
      </a-form-item>
      <!-- <a-form-item
        label="旺旺名"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          show-search
          :not-found-content="fetching ? undefined : null"
          :filter-option="false"
          @search="handleSearchAccount"
          @change="handleUaccountChange"
          v-decorator="[
            'uid',
            {
              rules: [{ required: true, message: '请输入搜索选择旺旺名' }]
            }
          ]"
          placeholder="请输入搜索选择旺旺名">
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in userDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item
        :required="true"
        label="选择订单"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <tcg-table
          style="margin-top:-10px;"
          ref="table"
          size="default"
          rowKey="order_id"
          :columns="columns"
          :data="loadData"
          bordered
        >
          <span slot="action" slot-scope="text, record">
            <template>
              <a v-if="record.order_id === data.order_id">已选择</a>
              <a v-if="record.order_id !== data.order_id" @click="selectOrders(record)">选择</a>
            </template>
          </span>
        </tcg-table>
      </a-form-item>
      <a-form-item
        :required="true"
        label="上传作文"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-upload
          name="file"
          :multiple="false"
          list-type="text"
          action="/index.php/upload_file/uploadFile?type=zwpath"
          @change="handleZwpathChange"
        >
          <a-button><a-icon type="upload" />点击上传</a-button>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { getPre, getList, getDictByCourse } from '@/api/orders'
import { searchUser } from '@/api/member'
import { yuYue } from '@/api/subscribe'
import { valInDict } from '@/utils/util'
import _ from 'lodash'
import { TcgTable } from '@/components'
export default {
  components: {
    TcgTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    planDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      // form-item标题样式
      labelCol: { lg: { span: 4 }, sm: { span: 5 } },
      // form-item组件样式
      wrapperCol: { lg: { span: 20 }, sm: { span: 19 } },
      // 抽屉加载
      loading: false,
      viewDetailData: {},
      // 字典
      dict: {},
      userDict: [],
      fetching: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        uaccount: '',
        isYuyue: 'YES',
        ctname: ''
      },
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'order_id'
        },
        {
          title: '课程名称',
          dataIndex: 'cname'
        },
        {
          title: '开始时间',
          dataIndex: 'stime'
        },
        {
          title: '截止时间',
          dataIndex: 'etime'
        },
        {
          title: '可预约',
          dataIndex: 'surplus_num'
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      modalTitel: '预约',
      confirmLoading: false,
      form: this.$form.createForm(this),
      data: {
        uid: '',
        uaccount: '',
        order_id: 'ALL',
        ctype: '',
        ttype: '',
        course_id: '',
        zwpath: '',
        tid: this.planDetail.tid,
        days: '',
        times: ''
      }
    }
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.values = _.get(res, 'values', {})
        }
      })
    },
    handleSearchAccount (value) {
      console.log(value)
      if (value === '') {
        return false
      }
      this.userDict = []
      this.fetching = true
      searchUser({ account: value }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.userDict = _.get(res, 'data', [])
          this.fetching = false
        }
      })
    },
    handleUaccountChange (value) {
      this.data.uid = value
      const uaccount = valInDict(this.data.uid, this.userDict, 'id', 'name', '')
      this.queryParam.uaccount = this.data.uaccount = uaccount
      this.$refs.table.refresh(true)
    },
    selectOrders (record) {
      this.data.order_id = record.order_id
      this.data.course_id = record.cid
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },    
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const fileUrl = _.get(info.file, 'response.data.url')
        if (targetId === 'zwpath') {
          this.data.zwpath = path
        }
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleZwpathChange (info) {
      this.handleFileUpload(info, 'zwpath')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    // 弹窗保存按钮
    handleOk (e) {
      // 判断是否有上传作文
      if (!this.data.zwpath) {
        this.$message.warning('请上传作文')
        return false
      }
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const formData = Object.assign(this.data, values)
          yuYue(formData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.confirmLoading = false
              this.$message.success('预约成功')
              this.$emit('finish')
            } else {
              this.confirmLoading = false
            }
          })
        }
      })
    },
    handleCancel () {
      this.$emit('hide')
    }
  },
  created () {
    // this.handelPre()
    this.modalTitel = this.planDetail.ctype + '预约'
    this.data.ctype = this.planDetail.ctype
    if (this.planDetail.ctname === 'Task1') { 
      this.data.ttype = 'T1'
    } else {
      this.data.ttype = 'T2'
    }
    this.queryParam.ctname = this.planDetail.ctname
  }
}
</script>
